<template>
  <div id="app">
    <navbar></navbar>
    <router-view />
    <!--  v-if="!($route.path=='/yqLink')" -->
    <div>
      <div v-if="$route.path=='/home'" style="width: 1100px;margin: 0 auto 50px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: flex;align-items: center;">
        <img style="width: 80px;height: 80px;margin-right: 18px;" src="./assets/logo.png" alt="">
        <div style="width: 65%;">
          <div style="color: #0069AE;font-size: 24px;margin-bottom: 6px;">广东省电子信息行业协会</div>
          <div style="color: #0069AE;font-size: 16px;">Guangdong Electronics and Information Industry Association</div>
        </div>
      </div>
      <div style="display: flex;align-items: center;width: 60%;justify-content: end;">
        <div style="width: 300px;">
          <div>
            <img style="width: 30px;height: 30px;" src="./assets/iphone.png" alt="">
            <span style="margin-left: 6px;">{{ data.info.contract }}</span>
          </div>
          <div v-if="data.info.qq_show === 1">
            <img style="width: 30px;height: 30px;" src="./assets/qq.png" alt="">
            <span style="margin-left: 6px;">{{ data.info.qq }}</span>
          </div>
          <div v-if="data.info.wechat_show === 1">
            <img style="width: 30px;height: 30px;" src="./assets/wx.png" alt="">
            <span style="margin-left: 6px;">{{ data.info.wechat }}</span>
          </div>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div v-if="data.info.douyin_show === 1" style="margin: 0 6px;">
            <img style="width: 100px;height: 100px;" :src="data.info.douyin" alt="">
            <div style="text-align: center;margin-top: 6px;">抖音号</div>
          </div>
          <div v-if="data.info.official_show === 1" style="margin: 0 6px;">
            <img style="width: 100px;height: 100px;" :src="data.info.official" alt="">
            <div style="text-align: center;margin-top: 6px;">公众号</div>
          </div>
          <div v-if="data.info.video_show === 1" style="margin: 0 6px;">
            <img style="width: 100px;height: 100px;" :src="data.info.video" alt="">
            <div style="text-align: center;margin-top: 6px;">视频号</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$route.path=='/home'" style="width: 1100px;margin: 0 auto 100px;background-color: #fff;padding: 20px 30px;">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="display: flex;align-items: center;">
          <img style="width: 24px;height: 24px;" src="./assets/fff.png" alt="">
          <span style="font-size: 28px;margin-left: 10px;">友情链接</span>
        </div>
        <div style="color: #CCCCCC;font-size: 14px;cursor: pointer;" @click="yqClick">
        <a target="_blank" href="#/yqLink">更多</a>
        </div>
      </div>
      <div style="display: flex;flex-wrap: wrap;padding-top: 12px;">
        <div v-for="(item, index) in data.link" style="font-size: 16px;color: #999999;width: 30%;text-align: center;margin: 12px 0;">
          <a target="_blank" :href="item.link" style="font-size: 16px;color: #999999;width: 30%;text-align: center;">{{ item.name }}</a>
        </div>
      </div>
    </div>
    <div class="footer_box">
      <div style="padding: 0 200px;">
        <div style="margin-bottom: 12px;">
          Copyright 2008-2015 广东电子信息行业网 All rights reserved ICP备案号 粤ICP备13073663号 技术支持：祺诚科技
        </div>
        <div>
          主办单位: 广东省电子信息行业协会 办公电话：020-83647119 83647101 协会QQ群（会员交流）：200523140
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { postConfig } from "@/request/api";

export default {
  name: "App",
  data() {
    return {
      data: {
        info: {}
      }
    };
  },
  created() {
    postConfig().then((res) => {
        if (res.code === 1) {
          this.data = res.data
          console.log(res);
        }
      });
  },
  methods: {
    yqClick() {
      // this.$router.push('/yqLink')
    }
  }
};
</script>

<style lang="scss">
#app {
  box-sizing: border-box;
  background-color: #eff7fd;
  // padding-bottom: 100px;
}
.footer_box{
  width: 100%;
  padding: 50px 0;
  text-align: center;
  background: #0069ae;
  color: #fff;
  font-size: 14px;
  // font-weight: bold;
  // position: fixed;
  // bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue